import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import ErrorComponent from '@/components/error';
import Subsection from '../subsection';
import Content from './components/content';
import Loading from './components/loading';
import useOnboardingDocuments from './hooks/use-onboarding-documents';
type OnboardingDocumentsProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  shouldUseSeqno?: boolean;
};
const OnboardingDocuments = t0 => {
  const $ = _c(12);
  const {
    entity,
    onboarding,
    shouldUseSeqno: t1
  } = t0;
  const shouldUseSeqno = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings.documents"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const {
    documents,
    isPending,
    error
  } = useOnboardingDocuments(entity, onboarding);
  const noDocuments = documents && documents.length === 0;
  if (noDocuments) {
    let t3;
    if ($[1] !== t) {
      t3 = t(_temp);
      $[1] = t;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== t3) {
      t4 = <Subsection><p className="text-body-2 text-tertiary">{t3}</p></Subsection>;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t3;
  if ($[5] !== documents || $[6] !== entity || $[7] !== error || $[8] !== isPending || $[9] !== onboarding || $[10] !== shouldUseSeqno) {
    t3 = documents ? <Content entity={entity} documents={documents} seqno={shouldUseSeqno ? onboarding.seqno : undefined} /> : <Subsection>{isPending && <Loading />}{error && <ErrorComponent error={error} />}</Subsection>;
    $[5] = documents;
    $[6] = entity;
    $[7] = error;
    $[8] = isPending;
    $[9] = onboarding;
    $[10] = shouldUseSeqno;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default OnboardingDocuments;
function _temp($) {
  return $.empty;
}